import React from 'react';

// PM‑editable copy separated from UI
export const setupTourCopy = {
  headerTitle: 'Setup Your Retirement Plan',
  headerBody: 'Configure your retirement planning assumptions and parameters. These settings drive all projections.',
  basicTitle: 'Basic Information',
  basicBody: 'Enter your current age, retirement year, and when you want projections to start. This sets your timeline.',
  assumptionsTitle: 'Financial Assumptions',
  assumptionsBody: 'Set default inflation rates, income growth, post-retirement returns, and margin of safety for projections.',
  horizonTitle: 'Projection Horizon',
  horizonBody: 'Choose how many years into the future you want to project (typically 20-30 years).',
  saveTitle: 'Save Your Setup',
  saveBody: 'Once saved, these assumptions will be used across all modules for consistent projections.',
};

const Tip = ({ title, body }) => (
  <div>
    <div style={{ fontWeight: 600, color: 'var(--foreground, #111827)' }}>{title}</div>
    <div style={{ marginTop: 6, fontSize: 14, color: 'var(--muted-foreground, #6B7280)' }}>{body}</div>
  </div>
);

export const getSetupTourSteps = () => [
  {
    target: '[data-tour="setup-header"]',
    content: <Tip title={setupTourCopy.headerTitle} body={setupTourCopy.headerBody} />,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="setup-basic"]',
    content: <Tip title={setupTourCopy.basicTitle} body={setupTourCopy.basicBody} />,
    placement: 'right',
  },
  {
    target: '[data-tour="setup-assumptions"]',
    content: <Tip title={setupTourCopy.assumptionsTitle} body={setupTourCopy.assumptionsBody} />,
    placement: 'right',
  },
  {
    target: '[data-tour="setup-save"]',
    content: <Tip title={setupTourCopy.saveTitle} body={setupTourCopy.saveBody} />,
    placement: 'top',
  },
];
